import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { beliefSteps } from '../../data/deckContent';
export function StoryMethodSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The story method" index={9} chapter="tactics" data-id="element-222" data-mp="1rhpgt0i7p2r9">
      <div data-id="element-223" data-mp="1mkfkd0wenqtx">
        <div className="flex items-end justify-between gap-[3vw]" data-id="element-224" data-mp="1mkpcov4xaa2s">
          <div data-id="element-225" data-mp="yta6gra0z8m9">
            <h2 className="max-w-[26ch] text-[clamp(22px,3.1vw,55px)] font-semibold leading-[1.06] tracking-tight text-white" data-id="element-226" data-mp="yuuxi6x4s9fd">
              Don’t tell experts what they already know.
            </h2>
            <p className="mt-[1.4vh] text-[clamp(13px,1.5vw,28px)] font-light text-[color:var(--sv-green)]" data-id="element-227" data-mp="18t124wabntnx">
              Give them a reason to update what they believe.
            </p>
          </div>
          <span className="hidden shrink-0 text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.3em] text-white/25 md:block" data-id="element-228" data-mp="2k5tofrkcfpwl">
            Internal method: Bayesian story build
          </span>
        </div>

        <ol className="mt-[3.5vh] grid grid-cols-4 gap-[1.4vw]" data-id="element-229" data-mp="1b54s32wjs55t">
          {beliefSteps.map((step, i) => {
          const isLast = i === beliefSteps.length - 1;
          return <motion.li key={step.order} initial={reduced ? false : {
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.34,
            delay: 0.06 * i,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col border-t pt-[1.8vh] ${isLast ? 'border-[color:var(--sv-green)]' : 'border-white/15'}`} data-id="element-230" data-mp="1l5592i6y296u" data-mpi={i}>
                <span className={`text-[clamp(10px,1vw,19px)] font-semibold tabular-nums ${isLast ? 'text-[color:var(--sv-green)]' : 'text-white/35'}`} data-id="element-231" data-mp="9ox46a41ils0">
                  {step.order}
                </span>
                <span className="mt-[1.2vh] text-[clamp(8px,0.78vw,14px)] font-medium uppercase tracking-[0.24em] text-white/45" data-id="element-232" data-mp="1c34smcpt47tg">
                  {step.label}
                </span>
                <span className={`mt-[1.4vh] text-[clamp(11px,1.25vw,24px)] font-light leading-snug ${isLast ? 'text-white' : 'text-white/75'}`} data-id="element-233" data-mp="1lseng0c1c4l9">
                  {step.text}
                </span>
              </motion.li>;
        })}
        </ol>

        <p className="mt-[4.5vh] max-w-[62ch] text-[clamp(12px,1.35vw,26px)] font-light leading-snug text-white/60" data-id="element-234" data-mp="1741nks9tu1lh">
          The best Solventum Snaks do not explain the obvious.{' '}
          <span className="font-medium text-white" data-id="element-235" data-mp="2ihdujc0vv0bv">
            They change the weight of an existing belief.
          </span>
        </p>
      </div>
    </SlideFrame>;
}